export default (ctx) => {
  if (
    !ctx.store.getters['auth/permittedPrograms'].includes(
      ctx.route.params.programIdentifier
    )
  )
    ctx.redirect('/error/403')
}
